import React from 'react'
import { Tag } from 'antd'
import classNames from 'classnames'

import { Icon } from '@app/components/util'

import { ICON_SIZE } from '@app/constants/button'
import { ICON_NAME } from '@app/constants/icon'

import { isFunction } from '@app/typeGuards'

import { getStylesClassName } from '@app/utils/styles'

import styles from './styles.module.scss'

import type { MouseEvent } from 'react'
import type { LntTagProps } from './types'

const block = 'tag'

export const LntTag: React.FC<LntTagProps> = props => {
  const { type, className: outerClassName, children, disabled, onClose, ...restProps } = props

  const typeClassName: string | undefined = getStylesClassName(styles, { block, modificator: type })
  const typeCloseButtonClassName: string | undefined = getStylesClassName(styles, {
    block,
    element: 'closeButton',
    modificator: type
  })

  const className: string = classNames(styles.tag, typeClassName, { [styles.tag_disabled]: disabled }, outerClassName)

  const closeButtonClassName: string = classNames(styles.tag__closeButton, typeCloseButtonClassName, {
    [styles.tag__closeButton_disabled]: disabled
  })

  const handleClose = (event: MouseEvent<HTMLElement>): void => {
    !disabled && onClose?.(event)
  }

  const closeButton = isFunction(onClose) && (
    <Icon
      className={ closeButtonClassName }
      name={ ICON_NAME.close }
      size={ ICON_SIZE }
      onClick={ handleClose }
    />
  )

  return (
    <Tag
      { ...restProps }
      className={ className }
    >
      { children }
      { closeButton }
    </Tag>
  )
}
